import { getUuid } from '@/utils/commonUtil'
import { getDateYYYYMMDDHHMISS } from '@/utils/dateUtil'
import config from '@/conf/config'

export function getHeader() {
    console.log('header.js - 开始生成请求头')
    
    // 这里可以添加token等认证信息
    const token = localStorage.getItem('token')
    console.log('header.js - 从localStorage获取token:', token)
    
    let authorization = ""
    if (token) {
        authorization = `Bearer ${token}`
        console.log('header.js - 生成Authorization:', authorization)
    } else {
        console.log('header.js - 未找到token，Authorization为空')
    }
    
    const uuid = getUuid()
    console.log('header.js - 生成TRANSACTION-ID:', uuid)
    
    const reqTime = getDateYYYYMMDDHHMISS()
    console.log('header.js - 生成REQ-TIME:', reqTime)
    
    console.log('header.js - appId:', config.appId)
    
    const header = {
        Authorization: authorization, // Adjust as needed
        'app-id': config.appId,
        'TRANSACTION-ID': uuid,
        'REQ-TIME': reqTime,
        'SIGN': '',
        'user-id': '-1'
    }
    
    console.log('header.js - 生成的请求头:', header)
    return header
}